import React, { useState } from 'react';
import axios from 'axios';
import {
    BrowserRouter as Router,
    Routes, useLocation,
    Route, Link
} from "react-router-dom";
import AtdHome from '../attendance/AtdHome';
import AtdSes from '../attendance/AtdSes';
import Test from '../Test';
import Setting from '../attendance/Setting';
import ResHome from '../result/ResHome';
import AccountInfo from './elements/AccountInfo';
import Notification from './elements/Notification';
import Notifications from '../updates/Notifications';
import DateSheet from '../datasheet/DateSheet';
import ExamDates from '../updates/ExamDates';
import TimeTable from '../updates/TimeTable';
import MainHome from './page/MainHome';
export default function Dashboard({ data }) {
    const location = useLocation();
    const path = location.pathname;
    const segments = path.split('/');
    const firstSegment = segments[1] || '';

    const [sidemenu, setSidemenu] = useState(false);
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);

    const toggleSidemenu = () => setSidemenu(!sidemenu);
    const toggleProfileMenu = () => setProfileMenuOpen(!profileMenuOpen);
    const handleLogout = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_ACCOUNT_API_URL}/logout`, {}, { withCredentials: true });
            if (response.data.success) {
                window.location.reload();
            }
        } catch (error) {
            alert(error);
        }
    }

    const loginbtn = () => {
        const redirect = window.location;
        window.location = process.env.REACT_APP_ACCOUNT_APP_URL + "/signup?redirect=" + redirect
    }
    const navData = [
        { name: 'Dashboard', icon: 'dashboard', link: '' },
        { name: 'Attendance', icon: 'attendance', link: 'attendance' },
        { name: 'Results', icon: 'result', link: 'results' },
        { name: 'Exam Dates', icon: 'examdates', link: 'examdates' },
        { name: 'Time Table', icon: 'tt', link: 'timetable' },
    ]
    return (

        <div className="antialiased bg-gray-200">
            <div className="h-screen flex overflow-hidden">
                {/* Mobile Sidebar */}
                <div className="md:hidden">
                    <div
                        onClick={() => setSidemenu(false)}
                        className={`fixed inset-0 z-20 bg-gray-600 opacity-0 pointer-events-none transition-opacity ease-linear duration-300 ${sidemenu ? 'opacity-75 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
                    ></div>

                    {/* Small Screen Menu */}
                    <div
                        className={`fixed inset-y-0 left-0 flex flex-col z-20 max-w-xs w-full bg-white transform ease-in-out duration-300 ${sidemenu ? 'translate-x-0' : '-translate-x-full'}`}
                    >
                        {/* Brand Logo / Name */}
                        <div className="flex items-center px-6 py-3 h-16">
                            <div className='flex items-center'><img className='h-7 rounded-lg mr-2' src='./img/logo192.png' /><div className="text-2xl font-bold tracking-tight siteLogo">NIT Nexus</div></div>
                        </div>
                        {/* Menu */}
                        <div className="px-4 py-2 flex-1 h-0 overflow-y-auto">
                            <ul>
                                {navData.map((item, index) => (
                                    <li key={index}>
                                        <Link
                                            to={"/" + item.link}
                                            onClick={toggleSidemenu}
                                            className={"mb-1 px-2 py-2 rounded-lg flex items-center font-medium text-gray-700 hover:bg-gray-200 " + (firstSegment === item.link ? 'bg-gray-200' : '')}
                                        >
                                            <img src={`./img/navicons/${item.icon}.svg`} className="w-6 h-6 mr-4 opacity-50" alt={item.name} />
                                            {item.name}
                                        </Link>
                                    </li>)
                                )}
                            </ul>
                        </div>
                    </div>
                </div>

                {/* Sidebar for larger screens */}
                <div className="bg-white w-64 min-h-screen overflow-y-auto hidden md:block shadow">
                    <div className="flex items-center px-6 py-3 h-16">
                        <div className='flex items-center'><img className='h-7 rounded-lg mr-2' src='./img/logo192.png' /><div className="text-2xl siteLogo">NIT Nexus</div></div>
                    </div>
                    {/* Menu */}
                    <div className="px-4 py-2">
                        <ul>
                            {navData.map((item, index) => (
                                <li key={index}>
                                    <Link
                                        to={"/" + item.link}
                                        onClick={toggleSidemenu}
                                        className={"mb-1 px-2 py-2 rounded-lg flex items-center font-medium text-gray-700 hover:bg-gray-200 " + (firstSegment === item.link ? 'bg-gray-200' : '')}
                                    >
                                        <img src={`./img/navicons/${item.icon}.svg`} className="w-6 h-6 mr-4 opacity-50" alt={item.name} />
                                        {item.name}
                                    </Link>
                                </li>)
                            )}
                        </ul>
                    </div>
                </div>

                {/* Main content */}
                <div className="flex-1 flex-col relative z-0 overflow-y-auto">
                    <div className="px-4 md:px-8 py-2 h-16 flex justify-between items-center shadow-sm bg-white">
                        <div className="flex items-center w-2/3">
                            <input
                                className="bg-gray-200 focus:outline-none focus:shadow-outline focus:bg-white border border-transparent focus:border-gray-300 rounded-lg py-2 px-4 block w-full appearance-none leading-normal hidden md:block placeholder-gray-700 mr-10"
                                type="text"
                                placeholder="Search..."
                            />
                            <div
                                className="p-2 rounded-full hover:bg-gray-200 cursor-pointer md:hidden"
                                onClick={toggleSidemenu}
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="text-gray-600" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
                                    <line x1="4" y1="6" x2="20" y2="6" />
                                    <line x1="4" y1="12" x2="20" y2="12" />
                                    <line x1="4" y1="18" x2="20" y2="18" />
                                </svg>
                            </div>
                            {/* <div className="text-xl font-bold tracking-tight text-gray-800 md:hidden ml-2">NIT Nexus</div> */}
                            {/* <div class='main'>
                                <h2 class="first">NIT Nexus</h2>
                                <h2 class="second">NIT Nexus</h2>
                            </div> */}
                            <div className='flex ml-2 items-center md:hidden'><img className='h-7 rounded-lg' src='./nitkkrlogo.png' /><div className=''><div className='siteLogo tracking-tight md:hidden ml-2'>NIT Kurukshetra</div><div className='text-[9px] tracking-tight  md:hidden ml-2 text-gray-600'>Student Wellfare Website</div></div></div>

                        </div>

                        <div className="flex items-center">
                            {/* Profile Menu */}
                            <div className="relative">
                                <Notification />
                            </div>
                            {/* Profile Dropdown */}
                            <div className="relative">
                                <AccountInfo data={data} />
                            </div>
                        </div>
                    </div>


                    <Routes>
                        <Route path="/" element={<MainHome data={data} />} />
                        <Route path="/attendance" element={<AtdHome data={data} />} />
                        <Route path="attendance/:id" element={<AtdSes />} />
                        <Route path="attendance/settings/:id" element={<Setting />} />
                        <Route path="results" element={<ResHome />} />
                        <Route path="notifications" element={<Notifications />} />
                        <Route path="examdates" element={<ExamDates />} />
                        <Route path="timetable" element={<TimeTable />} />
                        <Route path="test" element={<Test />} />
                    </Routes>

                </div>
            </div>
        </div>
    )
}
